import { Toaster as Sonner } from "sonner";

/** The one toast stack (IMPLEMENTATION_PLAN.md §2.9); follows the colour scheme. */
export function Toaster() {
  return (
    <Sonner
      theme="system"
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast: "bg-card! text-card-foreground! border-border! shadow-lg!",
          description: "text-muted-foreground!",
        },
      }}
    />
  );
}

export { toast } from "sonner";
